import { listIcp } from "../../api/endpoints/icp.js";
import { useEntityList } from "./useEntityList.js";

export function useIcp() {
  return useEntityList({
    fetchFn: listIcp,
    searchFields: ["name", "industry", "segment", "fleetSize", "region", "status"],
  });
}
